import { type ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { SettingsSectionCard } from "@/features/seller-portal/SettingsSectionCard";
import { SELLER_PORTAL_NS } from "@/features/seller-portal/i18n";
import { VacationToggle } from "@/features/seller-dashboard/VacationToggle";
import type { MyShopProfile } from "@/features/seller-portal/api";

export function AvailabilitySection({
  profile,
  readOnly,
}: {
  profile: MyShopProfile;
  readOnly: boolean;
}): ReactElement {
  const { t } = useTranslation(SELLER_PORTAL_NS);
  return (
    <SettingsSectionCard
      title={t("settings.sections.availability")}
      testid="settings-section-availability"
    >
      <p className="text-sm text-[var(--g-ink-2)]">
        {t(
          profile.seller.vacation_mode
            ? "settings.availability.vacationOn"
            : "settings.availability.vacationOff",
        )}
      </p>
      {/* VacationToggle is self-contained — owns its own GET/PUT and state */}
      <div
        aria-disabled={readOnly}
        className={readOnly ? "pointer-events-none opacity-50" : ""}
      >
        <VacationToggle />
      </div>
    </SettingsSectionCard>
  );
}
